export function ModalOverrides() {
  return {
    MuiModal: {
      defaultProps: {
        slotProps: {
          backdrop: {
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
            },
          },
        },
      },
    },
  }
}
